import S from 'common/service/sanctuary';
import { over, lensProp } from 'ramda';
import { scopedType } from '../scope/type';

// wraps existing action creator with namespaced type
const scopedAction$ = (namespace, actionCreator) => (...args) => over(
  lensProp('type'),
  scopedType(namespace),
  actionCreator(...args),
);

export const scopedAction = S.curry2(scopedAction$);

const factory$ = (namespace, actionCreators) => S.map(
  scopedAction(namespace),
  actionCreators,
);

export const factory = S.curry2(factory$);

export default factory;
